'use client';

import {
  AppleIcon,
  ChromeIcon,
  GithubIcon,
  Logo,
  MpIcon,
  WeiboIcon,
  WeiXinIcon,
  WindowsIcon,
  ZhiHuIcon,
} from '@/components/icons';
import { Button } from '@/components/ui/button';
import { Separator } from '@/components/ui/separator';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { MCP_URL, OPENAPI_URL } from '@/lib/constants';
import Image from 'next/image';
import Link from 'next/link';

export const Footer = () => {
  return (
    <div className="bg-neutral-50 dark:bg-[#212121]" id="footer">
      <div className="py-12 grid grid-cols-1 md:grid-cols-5 max-w-6xl mx-auto px-4 xl:px-0 gap-8 md:gap-4">
        <div className="col-span-2 md:col-span-1">
          <div className="font-semibold mb-4">应用&插件</div>
          <div className="flex flex-col md:gap-y-3">
            <Link
              href="/landing/zotero"
              className="md:md:text-sm hover:underline flex items-center gap-x-1 border-b dark:border-neutral-700 w-full py-2.5 md:border-none md:py-0"
            >
              <Image
                src="/img/zotero-logo.png"
                width={16}
                height={16}
                alt="Suppr Zotero 插件"
                sizes="16px"
              />
              Zotero 插件
            </Link>
            <Link
              href="https://www.wilddata.cn/1supprextension/"
              target="_blank"
              className="md:text-sm hover:underline flex items-center gap-x-1 border-b dark:border-neutral-700 w-full py-2.5 md:border-none md:py-0"
            >
              <ChromeIcon className="w-4 h-4" />
              浏览器插件
            </Link>
            <Link
              href="https://www.wilddata.cn/1suppraiwindowsmac/"
              target="_blank"
              className="md:text-sm hover:underline flex items-center gap-x-1 border-b dark:border-neutral-700 w-full py-2.5 md:border-none md:py-0"
            >
              <AppleIcon className="w-4 h-4" />
              Mac 客户端
            </Link>
            <Link
              href="https://www.wilddata.cn/1suppraiwindowsmac/"
              target="_blank"
              className="md:text-sm hover:underline flex items-center gap-x-1 border-b dark:border-neutral-700 w-full py-2.5 md:border-none md:py-0"
            >
              <WindowsIcon className="w-4 h-4" />
              Win 客户端
            </Link>
            <Tooltip>
              <TooltipTrigger asChild>
                <span className="md:text-sm hover:underline flex items-center gap-x-1 border-b dark:border-neutral-700 w-full py-2.5 md:border-none md:py-0 cursor-pointer">
                  <MpIcon className="w-4 h-4" />
                  微信小程序
                </span>
              </TooltipTrigger>
              <TooltipContent>
                <Image
                  alt="微信小程序"
                  width={258}
                  height={258}
                  src="/img/gh_21d610166629_430.jpg"
                  sizes="258px"
                />
              </TooltipContent>
            </Tooltip>
          </div>
        </div>
        <div className="col-span-2 md:col-span-1">
          <div className="font-semibold mb-4">定价</div>
          <div className="flex flex-col md:gap-y-3">
            <Link
              href="/pricing/subscribe"
              className="md:text-sm hover:underline border-b dark:border-neutral-700 w-full py-2.5 md:border-none md:py-0"
            >
              会员套餐
            </Link>
            <Link
              href="/pricing/credits"
              className="md:text-sm hover:underline border-b dark:border-neutral-700 w-full py-2.5 md:border-none md:py-0"
            >
              积分包
            </Link>
            <Link
              href="/pricing/api-credits"
              className="md:text-sm hover:underline border-b dark:border-neutral-700 w-full py-2.5 md:border-none md:py-0"
            >
              API 积分包
            </Link>
          </div>
        </div>
        <div className="col-span-2 md:col-span-1">
          <div className="font-semibold mb-4">服务</div>
          <div className="flex flex-col md:gap-y-3">
            <Link
              href="/"
              className="md:text-sm hover:underline border-b dark:border-neutral-700 w-full py-2.5 md:border-none md:py-0"
            >
              文献检索
            </Link>
            <Link
              href="/translate/upload"
              className="hover:underline md:text-sm border-b dark:border-neutral-700 w-full py-2.5 md:border-none md:py-0"
            >
              文档翻译
            </Link>
            <Link
              href="/deep-research"
              className="md:text-sm hover:underline border-b dark:border-neutral-700 w-full py-2.5 md:border-none md:py-0"
            >
              深度研究
            </Link>
            <Link
              href={OPENAPI_URL}
              className="md:text-sm hover:underline border-b dark:border-neutral-700 w-full py-2.5 md:border-none md:py-0"
              target="_blank"
            >
              API 文档
            </Link>
            <Link
              href={MCP_URL}
              className="md:text-sm hover:underline border-b dark:border-neutral-700 w-full py-2.5 md:border-none md:py-0"
              target="_blank"
            >
              MCP 服务
            </Link>
          </div>
        </div>
        <div className="col-span-2 md:col-span-1">
          <div className="font-semibold mb-4">关于我们</div>
          <div className="flex flex-col md:gap-y-3">
            <Link
              href="/about-us"
              className="md:text-sm hover:underline border-b dark:border-neutral-700 w-full py-2.5 md:border-none md:py-0"
            >
              关于 Suppr
            </Link>
            <Link
              href="https://www.wilddata.cn/"
              target="_blank"
              className="md:text-sm hover:underline border-b dark:border-neutral-700 w-full py-2.5 md:border-none md:py-0"
            >
              公司介绍
            </Link>
            <Link
              href="https://www.wilddata.cn/contact-us/"
              className="md:text-sm hover:underline border-b dark:border-neutral-700 w-full py-2.5 md:border-none md:py-0"
              target="_blank"
            >
              联系我们
            </Link>
            <Link
              href="/terms"
              className="md:text-sm hover:underline border-b dark:border-neutral-700 w-full py-2.5 md:border-none md:py-0"
            >
              用户协议
            </Link>
            <Link
              href="/privacy"
              className="md:text-sm hover:underline border-b dark:border-neutral-700 w-full py-2.5 md:border-none md:py-0"
            >
              隐私条款
            </Link>
          </div>
        </div>

        <div className="col-span-2 md:col-span-1">
          <div className="font-semibold mb-4">关注我们</div>
          <div className="flex flex-col md:gap-y-3">
            <div className="flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300 mb-3">
              <Button size="icon" variant="ghost" aria-label="微博" asChild>
                <Link
                  href="https://weibo.com/u/7774872543?tabtype=feed"
                  target="_blank"
                >
                  <WeiboIcon
                    className="fill-gray-700 dark:fill-gray-300"
                    size={24}
                  />
                </Link>
              </Button>
              <Button size="icon" variant="ghost" aria-label="知乎" asChild>
                <Link
                  href="https://www.zhihu.com/people/suppr-"
                  target="_blank"
                >
                  <ZhiHuIcon
                    className="fill-gray-700 dark:fill-gray-300"
                    size={24}
                  />
                </Link>
              </Button>

              <Tooltip>
                <TooltipTrigger asChild>
                  <Button size="icon" variant="ghost" aria-label="微信公众号">
                    <WeiXinIcon
                      className="fill-gray-700 dark:fill-gray-300 cursor-pointer"
                      size={24}
                    />
                  </Button>
                </TooltipTrigger>
                <TooltipContent>
                  <Image
                    alt="微信公众号"
                    width={258}
                    height={258}
                    src="/img/qrcode_for_gh_7a8a6bf50ba2_258.jpg"
                    sizes="258px"
                  />
                </TooltipContent>
              </Tooltip>

              <Button size="icon" variant="ghost" aria-label="GitHub" asChild>
                <Link href="https://github.com/WildDataX" target="_blank">
                  <GithubIcon
                    className="fill-gray-700 dark:fill-gray-300 cursor-pointer"
                    size={24}
                  />
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>

      <div className="dark:bg-background/80 bg-neutral-100 py-6">
        <div className="flex-1 max-w-6xl mx-auto flex items-center justify-between flex-col md:flex-row gap-2">
          <div className="flex items-center gap-x-2 text-sm flex-col md:flex-row">
            <div className="flex items-center gap-1 mb-2 md:mb-0">
              <Logo size={24} className="fill-default-600" />
              <h2>Suppr 超能文献</h2>
            </div>
            <Separator orientation="vertical" className="h-4 hidden md:block" />
            <span className="space-x-1">
              核心技术专利：
              <Link
                href="http://epub.cnipa.gov.cn/cred/CN118964589B"
                className="text-primary hover:underline mr-0.5"
                target="_blank"
              >
                CN118964589B
              </Link>
              侵权必究
            </span>
          </div>
          <div className="flex items-center gap-4 text-sm">
            <Link
              href="https://beian.miit.gov.cn/"
              target="_blank"
              className="text-primary hover:underline"
            >
              粤ICP备2023148730 号-1
            </Link>
            <span>Suppr @ {new Date().getFullYear()}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
